import * as React from 'react';
import * as classNames from 'classnames';
import {Component, CSSProperties, ReactNode} from 'react';
import * as _ from 'lodash';

import {IStoryData, IStoryDataOut} from '../../../service/contentServer';
import ContentParsed from './component/contentParsed';
import {getDirection, isRtl} from '../../common/language';
import {getMetas, setMetaInfoForNative} from '../../common/meta';
import {L} from '../../lang';
import {statClickOrigin} from './article.store';
import {waAction} from '../../common/wastat';

if (process.env.BROWSER) {
    require('./article.less');
}

const RefArticleBody: string = `outDiv`; // 来源于 ./component/contentParsed.tsx 的 ref
const DefaultPercentArticleInnerAd: number = 0.5;

interface IOptionsArticleInnerAd { // 单例文中广告
  percent?: number; // float 类型: 0 ~ 1
  reactNode: React.ReactNode;
}

interface IComponentProps {
  className?: string;
  style?: CSSProperties;
  hasFeatureReadMore?: boolean; // 是否需要文字折叠
  onClickReadMore?: () => void;
  hasFeatureArticleInnerAd?: boolean;
  optionsArticleInnerAd?: IOptionsArticleInnerAd;
  story: IStoryDataOut;
  itemId: string;
}
interface IComponentState {
  hasReadMore: boolean;
  insertAdAfterId?: string;
}

export default class Article extends Component<IComponentProps, IComponentState> {
  public refArticleBody: React.RefObject<any>;
  private didMountTime: number;
  constructor(props) {
    super(props);
    this.state = {
      hasReadMore: (props.hasFeatureReadMore === true) ? false : true,
      insertAdAfterId: undefined,
    };
    this.refArticleBody = React.createRef();
  }

  public gotoSource = (): void => {
    const raw: IStoryData = this.props.story.raw_item;
    statClickOrigin(raw.original_url);

    setTimeout(() => {
      location.href = raw.original_url;
    }, 500);
  }

  public getIsShowReadMore = (): boolean => {
    if (this.props.hasFeatureReadMore === true && this.state.hasReadMore === false) {
      return true;
    }
    return false;
  }

  public getDomStory = (): React.ReactNode => {
    if (this.props.story === undefined || this.props.story === null || this.props.story.raw_item === undefined || this.props.story.raw_item === null) {
      return null;
    }
    // 广告放在“更多内容”下面，会造成没看到广告也曝光，所以有“更多”按钮的时候，不显示广告
    const shouldHaveAd = !this.getIsShowReadMore();
    return (
      <ContentParsed ref={this.refArticleBody}
        story={this.props.story}
        insertAdAfterId={this.state.insertAdAfterId} // 广告ID
        insertAdComponent={shouldHaveAd ? this.props.optionsArticleInnerAd.reactNode : null}
      />
    );
  }

  public getDomReadMoreBtn = (): React.ReactNode => {
    const isShowReadMore: boolean = this.getIsShowReadMore();
    if (!isShowReadMore) { return null; }
    return (
      <div className={`article-readmore-container`} onClick={ this.handleReadMore.bind(this) }>
        <div className={`article-readmore-container-mask`} />
        <div className={`article-readmore-container-content`}>{ L('default.article_read_more') }</div>
      </div>
    );
  }

  public handleReadMore = (event): void => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ hasReadMore: true });
    if (this.props.onClickReadMore) { this.props.onClickReadMore(); }
  }

  public displayShowReadMore = (): void => {
    const isShowReadMore: boolean = this.getIsShowReadMore();
    if (!isShowReadMore) { return ; }
    // 如果长度 < 800px, 则隐藏正文的 read_more
    if (this.refArticleBody.current && this.refArticleBody.current[RefArticleBody].current) {
      const articleHeight: number = this.refArticleBody.current[RefArticleBody].current.offsetHeight;
      if (articleHeight < 800) {
        this.setState({ hasReadMore: true });
      }
    }
  }

  public getElementPositionPercent = (el: any): number => {
    if (getIsServer() === true) { return 0; }
    const domElementArticle: any = this.refArticleBody.current[RefArticleBody].current;
    if (domElementArticle === undefined || domElementArticle === null) { return 0; }
    if (el === undefined || el === null) { return 0; }
    const screenHeight = window.innerHeight;
    const elementTop: number = el.offsetTop + el.offsetHeight - domElementArticle.offsetTop;
    // return elementTop / screenHeight;
    // console.log('getElementPositionPercent', elementTop / domElementArticle.offsetHeight);
    return elementTop / domElementArticle.offsetHeight;
  }

  public displayArticleInnerAd = (): void => {
    if (getIsServer() === true) { return ; }
    const domElementArticle: any = this.refArticleBody.current[RefArticleBody].current;
    if (domElementArticle === undefined || domElementArticle === null) { return ; }
    const targetPercent: number = _.get(this.props, 'optionsArticleInnerAd.percent', DefaultPercentArticleInnerAd);

    // 判断是否插入广告
    const funcJudgeInsert = (parentElement: any): IFuncJudgeInsert => {
      const judge = (e: HTMLElement) => (e.nodeName !== 'IMG') &&  (this.getElementPositionPercent(e) >= targetPercent);
      const loop = (node, deep: number) => {
        if (deep >= 4) {
          if (judge(node)) {
            return node;
          } else {
            return;
          }
        }
        const nodes = node.childNodes;
        for (let i = 0; i < nodes.length; i++) {
          if (!nodes[i]) {
            continue;
          }

          if (nodes[i].childNodes.length > 0) {
            const r = loop(nodes[i], deep + 1);
            if (r) { return r; }
          }
        }
        if (judge(node)) {
          return node;
        }
      };
      // console.log('parentElement', parentElement);
      const resultDom = loop(parentElement, 0);
      // 上报文章ID和长度
      waAction({
        ac_name: 'apear',
        ac_type: 'event',
        pos: 'article',
        is_insert: resultDom ? true : false,
        article_id: this.props.itemId,
        cost_time: Date.now() - this.didMountTime,
      });
      if (resultDom) {
        return {
          hasInsert: true,
          domElement: resultDom,
        };
      }
      return {
        hasInsert: false,
        domElement: undefined,
      };
    };
    try {
      const resJudge: IFuncJudgeInsert = funcJudgeInsert(domElementArticle);
      if (resJudge.hasInsert === false) {
        // console.log('没有！', resJudge);
        return ;
      }
      // console.log('陈宫！', resJudge);
      this.funcInsertArticleInnerAd(resJudge.domElement);
    } catch (e) {
      console.log(`加载文中广告失败`);
      console.log(e);
    }
  }

  public funcInsertArticleInnerAd = (domElement: any): void => {
    // TODO: 广告 SDK加载
    // console.log('funcInsertArticleInnerAd', domElement.getAttribute('data-id'));
    this.setState({
      insertAdAfterId: domElement.getAttribute('data-id'),
    });
  }

  public render(): ReactNode {
    const raw: IStoryData = this.props.story.raw_item;
    const rtl = isRtl(raw);

    const isShowReadMore: boolean = this.getIsShowReadMore();
    const classStoryBody: string = classNames({
      'article-body-readmore': isShowReadMore,
      // 'article-body-readmore-hidden': !isShowReadMore,
    });
    const domStory: React.ReactNode = this.getDomStory();
    const domReadMore: React.ReactNode = this.getDomReadMoreBtn();

    return (
      <div style={{direction: getDirection(raw)}}>
        <h1 className="article-title" >{raw.title}</h1>

        <div className="article-meta-line">

          <span className="article-date" style={{float: rtl ? 'right' : 'left', direction: 'ltr'}}>
            {raw.dateDisplay}
          </span>
          <span className="article-source" style={{float: rtl ? 'left' : 'right'}}>
            {raw.source}
          </span>
        </div>
        {/*<p>{L('lang')}</p>*/}
        <div className={classStoryBody}>
        {/* domstory 混合广告的文章内容 */}
          { domStory }
          { domReadMore }
        </div>
        {
          raw.original_url && <div className="article-origin">
            <a href="javascript:void(0);" onClick={(e) => {
              e.preventDefault();
              this.gotoSource();
            }}>{L('default.origin')}</a>
          </div>
        }

        {...getMetas({
          type: 'article',
          title: raw.title,
          description: raw.title,
          imageUrl: raw.image[0] ? raw.image[0].optimalUrl || raw.image[0].url : null,
        })}
      </div>
    );
  }

  public componentDidMount(): void {
    this.displayShowReadMore();
    this.didMountTime = Date.now();
    // todo: 判断是否插入广告的标记
    if (this.props.hasFeatureArticleInnerAd === true) {
      this.displayArticleInnerAd();
    }
    const raw: IStoryData = this.props.story.raw_item;
    setMetaInfoForNative({
      url: location.href,
      title: raw.title,
      img_url: raw.image && raw.image[0] && raw.image[0].url,
      item_id: this.props.itemId,
      recoid: '',
      seed_icon_desc: raw.title,
      seed_icon_url: 'http://img.ucweb.com/s/uae/g/3f/site_logo/logo.png',
      source_name: raw.source,
    });
  }
}

interface IFuncJudgeInsert {
  hasInsert: boolean;
  domElement: any;
}

function getIsServer(): boolean {
  return typeof window === 'undefined';
}

function insertAfter(targetElement: any, newElement: any ): void {
  const parent = targetElement.parentNode; // 获取父级元素节点

  if (parent.lastChild === targetElement) {
    parent.appendChild(newElement);
  } else {
    parent.insertBefore(newElement, targetElement.nextSibling);
  }
}
